import React from 'react'

export default function ConnectButton(){
return (<>
<div className='connect-button-container'>Connect</div>
</>)
}